import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Header } from './Header.js';
import { Footer } from './Footer.js';
import { SkipLink } from './SkipLink.js';
import { ConfirmProvider } from '../ui/ConfirmProvider.js';

const TOAST_DURATION_MS = 6000;

export function AppLayout(): JSX.Element {
  return (
    <ConfirmProvider>
      <div className="flex min-h-screen flex-col">
        <SkipLink />
        <Header />
        <main id="main-content" className="mx-auto w-full max-w-6xl flex-1 px-4 py-8" tabIndex={-1}>
          <Outlet />
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" toastOptions={{ duration: TOAST_DURATION_MS }} />
    </ConfirmProvider>
  );
}
